import errorIcon from '../../../assets/images/error-icon.svg';
import './ErrorPage.scss';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation } from "../../../platform/stores/translationStore";

export const ErrorPage = observer(() => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('');
  const t = useTranslation();

  useEffect(() => {
    const messageQuery = searchParams.get('message') || '';
    const message = t(messageQuery) || 'Something went wrong';
    setMessage(message);
  }, []);

  return (
    <div className="error-page">
      <div className="black-layer">
        <div className="content">
          <div className="content-center">
            <img src={errorIcon} alt=""/>
          </div>
          <h2 className="message">{message}</h2>
        </div>
      </div>
    </div>
  );
});
